/* TL_ATC_MARKER_1786683600 */
/* titanore-board-atc-live 20260814i */
(function(){
  if (/\/products\/(sauteerpan|twee-handgrepen|wok-vlakke-bodem|hoge-rand|diepe-pan|crepepan|kookpan)(?:\/|$)/.test((location.pathname || '').toLowerCase())) return;
  if (document.getElementById('tl-board-buybox-css')) return;
  var s=document.createElement('style');
  s.id='tl-board-buybox-css';
  s.textContent="/* Titanoré board buy-box — matches pan ATC treatment (tl-cta). */\n#tl-board-buybox {\n  width: 100% !important;\n  max-width: 100% !important;\n  align-self: stretch !important;\n  box-sizing: border-box;\n  --tl-ink: #272727;\n  --tl-muted: #555555;\n  --tl-line: #e9e9e9;\n  --tl-accent: #6B1D28;\n  --tl-bg: #fcfaf6;\n  color: var(--tl-ink);\n  font-family: \"DM Sans\", \"Archivo\", system-ui, sans-serif;\n  margin: 0.75rem 0 1.25rem;\n}\n\n#tl-board-buybox .tl-buybox-head {\n  margin: 0 0 1rem;\n}\n\n#tl-board-buybox .tl-size-line {\n  margin: 0 0 0.35rem;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--tl-muted);\n}\n\n#tl-board-buybox .tl-promise {\n  margin: 0;\n  font-family: \"Instrument Serif\", \"Iowan Old Style\", Georgia, serif;\n  font-size: clamp(1.35rem, 2.4vw, 1.6rem);\n  font-weight: 400;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  color: var(--tl-ink);\n}\n\n#tl-board-buybox .tl-price {\n  display: flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: 0.5rem 0.85rem;\n  margin-bottom: 1.15rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--tl-line);\n}\n\n#tl-board-buybox .tl-price-now {\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: clamp(2.2rem, 4vw, 2.7rem);\n  line-height: 1;\n  font-weight: 400;\n}\n\n#tl-board-buybox .tl-price-was {\n  color: var(--tl-muted);\n  text-decoration: line-through;\n  font-size: 1rem;\n}\n\n#tl-board-buybox .tl-price-off {\n  color: var(--tl-accent);\n  font-size: 0.78rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n/* Match live pan ATC (.tl-shop-cta__btn): #6b1d28, 8px, white label */\n#tl-board-buybox .tl-cta {\n  width: 100%;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 48px;\n  background: #6b1d28;\n  color: #ffffff !important;\n  border: 0;\n  padding: 14px 20px;\n  font: inherit;\n  font-size: 15px;\n  font-weight: 650;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n}\n\n#tl-board-buybox .tl-cta:hover {\n  opacity: 0.92;\n  background: #6b1d28;\n}\n\n#tl-board-buybox .tl-cta:focus-visible {\n  outline: 2px solid #6b1d28;\n  outline-offset: 3px;\n}\n\n#tl-board-buybox .tl-cta:disabled {\n  opacity: 0.7;\n  cursor: wait;\n}\n\n#tl-board-buybox .tl-trust {\n  margin-top: 0.9rem;\n  text-align: center;\n  font-size: 0.8rem;\n  line-height: 1.4;\n  color: var(--tl-muted);\n}\n\n#tl-board-buybox .tl-trust strong {\n  color: var(--tl-ink);\n  font-weight: 600;\n}\n\n#tl-board-buybox .tl-pay {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem 0.6rem;\n  margin-top: 0.85rem;\n}\n\n#tl-board-buybox .tl-pay img {\n  display: block;\n  height: 22px;\n  width: auto;\n}\n\n#tl-board-buybox .tl-pay-pill {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 2px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  background: #f3f3f3;\n  color: #272727;\n}\n\n/* Hide Selluxe black bag ATC on board PDP when our buybox is present */\nbody.template-suffix-benefit-board-v3:has(#tl-board-buybox) .shop-product-info [class*=\"add-to-cart\"],\nbody.template-suffix-benefit-board-v3:has(#tl-board-buybox) .shop-product-info button[name=\"add\"],\nbody.template-suffix-benefit-board-v3:has(#tl-board-buybox) .shop-product-info .product-form__submit {\n  display: none !important;\n}\n";
  document.head.appendChild(s);
})();
/**
 * Titanoré board buy-box — pan-matching ATC.
 * EN: Add to cart · NL: In winkelwagen
 * Self-mounts on board PDP if theme template cache is stale.
 */
(function () {
  var VARIANT_ID = 57831485833603;

  function isBoardPdp() {
    if (document.getElementById('tl-board-buybox')) return true;
    if (document.body && /benefit-board/i.test(document.body.className || '')) return true;
    return /cutting-board|snijplank/i.test(location.pathname || '');
  }

  function currentLang() {
    try {
      if (window.Weglot && typeof Weglot.getCurrentLang === 'function') {
        return Weglot.getCurrentLang();
      }
    } catch (e) {}
    var path = (location.pathname || '').toLowerCase();
    if (path === '/nl' || path.indexOf('/nl/') === 0) return 'nl';
    var m = document.cookie.match(/(?:^|; )wglang=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : 'en';
  }

  function applyI18n(root) {
    var key = currentLang() === 'nl' ? 'nl' : 'en';
    (root || document).querySelectorAll('[data-en][data-nl]').forEach(function (el) {
      var next = el.getAttribute('data-' + key) || el.getAttribute('data-en');
      if (next != null) el.textContent = next;
    });
  }

  function syncStickyLabel() {
    var label = currentLang() === 'nl' ? 'In winkelwagen' : 'Add to cart';
    document.querySelectorAll('.sticky-add-to-cart .button-text').forEach(function (el) {
      el.textContent = label;
    });
    /* Force pan sticky look if old SHOP NOW black style still cached */
    var style = document.getElementById('tl-board-sticky-match');
    if (!style) {
      style = document.createElement('style');
      style.id = 'tl-board-sticky-match';
      style.textContent =
        'body.template-suffix-benefit-board-v3 .sticky-add-to-cart,' +
        'body.template-product.template-suffix-benefit-board-v3 .sticky-add-to-cart{' +
        'background:#1c2b1e!important}' +
        'body.template-suffix-benefit-board-v3 .sticky-add-to-cart button,' +
        'body.template-suffix-benefit-board-v3 .sticky-add-to-cart .button{' +
        'background:#6b1d28!important;color:#ffffff!important;border-radius:8px!important;' +
        'font-size:14px!important;font-weight:700!important;letter-spacing:.04em!important;' +
        'text-transform:none!important;min-height:44px!important}' +
        'body.template-suffix-benefit-board-v3 .shop-product-info button[name="add"],' +
        'body.template-suffix-benefit-board-v3 .shop-product-info .product-form__submit,' +
        'body.template-suffix-benefit-board-v3 .shop-product-info [class*="add-to-cart"]:not(#tl-board-buybox):not(#tl-board-buybox *){' +
        'display:none!important}';
      document.head.appendChild(style);
    }
  }

  function mountBuybox() {
    if (document.getElementById('tl-board-buybox')) return document.getElementById('tl-board-buybox');
    if (!isBoardPdp()) return null;

    var host =
      document.querySelector('.shop-product-info') ||
      document.querySelector('[class*="product-info"]') ||
      document.querySelector('product-info') ||
      document.querySelector('main .product');
    if (!host) return null;

    var box = document.createElement('div');
    box.id = 'tl-board-buybox';
    box.className = 'tl-board-buybox';
    box.setAttribute('data-variant-id', String(VARIANT_ID));
    box.innerHTML =
      '<div class="tl-buybox-head">' +
      '<p class="tl-size-line" data-en="Layered titanium · One board" data-nl="Gelaagd titanium · Één board">Layered titanium · One board</p>' +
      '<p class="tl-promise" data-en="Non-porous. Dishwasher safe. Built for daily prep." data-nl="Niet-poreus. Vaatwasserbestendig. Gemaakt voor dagelijkse prep.">Non-porous. Dishwasher safe. Built for daily prep.</p>' +
      '</div>' +
      '<div class="tl-price" aria-live="polite">' +
      '<span class="tl-price-now">€94</span>' +
      '<span class="tl-price-was">€157</span>' +
      '<span class="tl-price-off" data-en="40% SUMMER DISCOUNT" data-nl="40% ZOMERKORTING">40% SUMMER DISCOUNT</span>' +
      '</div>' +
      '<button type="button" class="tl-cta" data-cta data-en="Add to cart" data-nl="In winkelwagen">Add to cart</button>' +
      '<p class="tl-trust" data-en="Free returns · Juice channel · No PFAS / PFOA / PTFE coating" data-nl="Gratis retour · Sapgoot · Geen PFAS / PFOA / PTFE-coating"><strong>Free returns</strong> · Juice channel · No PFAS / PFOA / PTFE coating</p>';

    var anchor =
      host.querySelector('.price, [class*="product-price"], [class*="Price"]') ||
      host.querySelector('form[action*="/cart/add"]') ||
      host;
    if (anchor && anchor.parentNode) {
      if (anchor.matches('form') || /cart\/add/i.test(anchor.getAttribute('action') || '')) {
        anchor.parentNode.insertBefore(box, anchor);
      } else {
        anchor.parentNode.insertBefore(box, anchor.nextSibling);
      }
    } else {
      host.appendChild(box);
    }
    return box;
  }

  function wire(root) {
    if (!root || root.getAttribute('data-wired') === '1') return;
    root.setAttribute('data-wired', '1');
    var cta = root.querySelector('[data-cta]');
    if (!cta) return;

    function setBusy(busy) {
      cta.disabled = !!busy;
      if (busy) {
        cta.setAttribute('data-prev', cta.textContent || '');
        cta.textContent = currentLang() === 'nl' ? 'Bezig…' : 'Adding…';
      } else {
        var prev = cta.getAttribute('data-prev');
        if (prev) cta.textContent = prev;
        applyI18n(root);
      }
    }

    cta.addEventListener('click', function (e) {
      e.preventDefault();
      if (cta.disabled) return;
      setBusy(true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: VARIANT_ID, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add_failed');
          window.location.href = '/cart';
        })
        .catch(function () {
          setBusy(false);
          window.location.href = '/products/titanium-cutting-board?variant=' + VARIANT_ID;
        });
    });
  }

  function boot() {
    if (!isBoardPdp()) return;
    var root = document.getElementById('tl-board-buybox') || mountBuybox();
    if (root) {
      applyI18n(root);
      wire(root);
    }
    syncStickyLabel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  setTimeout(boot, 600);
  setTimeout(boot, 1600);

  try {
    if (window.Weglot && typeof Weglot.on === 'function') {
      Weglot.on('languageChanged', function () {
        var root = document.getElementById('tl-board-buybox');
        if (root) applyI18n(root);
        syncStickyLabel();
      });
    }
  } catch (e) {}
})();

;/* boardlux-20260814c — board PDP/LP client fixes for sticky theme-cache leftovers */
(function () {
  var isBoardPath = /cutting-board|snijplank/i.test(location.pathname || '');
  if (!isBoardPath && !document.body.classList.contains('template-suffix-benefit-board-v3')) {
    /* still run card rewrite below if okp board mode */
  }

  /* Positive benefit cards — rewrite sticky Shopify page-cache leftovers. */
  try {
    var root = document.querySelector('.okp[id^="okp-"], section.okp');
    if (root) {
      var ey = root.querySelector('.okp-ey');
      var ti = root.querySelector('.okp-ti');
      var su = root.querySelector('.okp-su');
      var cards = root.querySelectorAll('.okp-card');
      var firstTitle = cards.length
        ? ((cards[0].querySelector('.okp-card-ti') || {}).textContent || '').trim()
        : '';
      var isBoard =
        root.getAttribute('data-okp-mode') === 'board' ||
        isBoardPath ||
        /Grooves harbor|Soft wood warps|Plastic wears|Non-porous|Prep that stays/i.test(
          firstTitle + ' ' + (root.textContent || '')
        );
      var needsRewrite =
        /Coatings fail|Soft surfaces scratch|Results you can't trust|Grooves harbor|Soft wood warps|Plastic wears|The reality|Natural release|Metal utensils|sear you can trust|540/i.test(
          root.textContent || ''
        ) || isBoard;

      if (needsRewrite && isBoard && cards.length) {
        var board = {
          ey: 'The standard',
          ti: 'Prep that stays clean',
          su: 'Layered titanium boards: non-porous, knife-true, built to stay flat through years of prep.',
          cards: [
            {
              title: 'Non-porous by design',
              text: 'Juice stays on the surface. Wipe clean. Dishwasher safe.',
              img: 'tl-board-ugc-poster-1.jpg'
            },
            {
              title: 'Stays flat and true',
              text: 'Flat, stable, and ready for daily prep, year after year.',
              img: 'tl-board-reality-prep.jpg'
            },
            {
              title: 'Knife-true prep',
              text: 'A hard, even surface that keeps your edge honest, meal after meal.',
              img: 'tl-board-ugc-poster-3.jpg'
            }
          ]
        };
        if (ey) ey.textContent = board.ey;
        if (ti) ti.textContent = board.ti;
        if (su) su.textContent = board.su;

        var assetBase = '';
        var scripts = document.querySelectorAll('script[src*="/assets/"]');
        for (var i = 0; i < scripts.length; i++) {
          var src = scripts[i].getAttribute('src') || '';
          var m = src.match(/^(.*\/assets\/)/);
          if (m) {
            assetBase = m[1];
            break;
          }
        }
        if (!assetBase) assetBase = '/cdn/shop/t/16/assets/';

        cards.forEach(function (card, idx) {
          var conf = board.cards[idx];
          if (!conf) return;
          var ct = card.querySelector('.okp-card-ti');
          var cx = card.querySelector('.okp-card-tx');
          var img = card.querySelector('.okp-card-img img');
          if (ct) ct.textContent = conf.title;
          if (cx) cx.textContent = conf.text;
          if (img && conf.img) {
            var url = assetBase + conf.img;
            img.setAttribute('src', url);
            img.setAttribute('srcset', '');
            img.setAttribute('alt', conf.title);
          }
        });
        root.setAttribute('data-okp-stills', 'v3c-client');
        root.setAttribute('data-okp-mode', 'board');
      }
    }
  } catch (e) {}

  /* Board PDP: scrub pan leftovers in FAQ + feature callouts (theme cityhash lag). */
  try {
    if (!isBoardPath && !document.body.classList.contains('template-suffix-benefit-board-v3')) return;

    var faqFixes = [
      {
        test: /540|cooktop|hand-hammered|cast iron|cooking fat|Preheat/i,
        html:
          '<ul><li><strong>Non-porous layered titanium</strong> cutting surface</li><li><strong>Dishwasher safe</strong> · rinse or run a cycle</li><li><strong>Juice channel</strong> for cleaner counters</li><li><strong>No PFAS / PFOA / PTFE coating</strong></li><li><strong>Stays flat</strong> · resists warping vs wood and soft plastic</li></ul>'
      }
    ];

    document.querySelectorAll('.faq-answer, .faq-item, [class*="faq"] , .accordion, details').forEach(function (el) {
      var t = el.textContent || '';
      if (/540|cooktop|hand-hammered cooking|Preheat gradually/i.test(t)) {
        var inner = el.querySelector('.faq-answer-inner, .answer, .accordion__content, p, ul');
        if (inner && /540|cooktop|Preheat/i.test(inner.textContent || '')) {
          inner.innerHTML = faqFixes[0].html;
        }
      }
    });

    /* Selluxe product feature cards that still mention pan heat */
    document.querySelectorAll('.pf-title, .feature-title, [class*="product-feature"]').forEach(function (el) {
      var t = (el.textContent || '').trim();
      if (/540|extreme heat/i.test(t)) {
        el.textContent = 'Dishwasher safe cleanup';
        var det = el.parentElement && el.parentElement.querySelector('.pf-det, .feature-detail, p');
        if (det) det.textContent = 'Rinse or wipe between tasks. For deeper cleans, put it in the dishwasher. No oiling or seasoning rituals.';
      }
      if (/Even heat everywhere/i.test(t)) {
        el.textContent = 'Stays flat through wet cycles';
        var det2 = el.parentElement && el.parentElement.querySelector('.pf-det, .feature-detail, p');
        if (det2)
          det2.textContent =
            'Wood can warp. Soft plastic scars. Layered titanium stays true for confident knife work, meal after meal.';
      }
      if (/Solid Titanium Surface/i.test(t) && /cooking surface/i.test((el.parentElement && el.parentElement.textContent) || '')) {
        el.textContent = 'Layered titanium cutting surface';
      }
    });

    /* Hide pan buybox inject leftovers if present */
    document.querySelectorAll('[id*="titanore-pan-buybox"], .tl-pan-buybox, [data-tl-pan-buybox]').forEach(function (n) {
      n.style.display = 'none';
    });
  } catch (e2) {}
})();
